import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de ingreso de matriz
const devuelNumNivelesCarrera = ApiUrl + "numnivelescarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarAsignMatCiclo = ApiUrl + "ListarAsignMatCiclo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModAsignatura = ApiUrl + "ModificarAsignatura" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngrAsignatura = ApiUrl + "IngresarAsignatura" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class AsignaturasEstCarreraCicloAdm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            periodos: [],
            periodosId: [],
            periodoId: '',
            nivel1: '',
            nivel2: '',
            nivel3: '',
            nivel4: '',
            nivel5: '',
            nivel6: '',
            EstudianteBackup: [],

            carrera_seleccionada: '',
            ciclo_seleccionado: '',
            carrera: [],
            usuario_moodle: [],
            estado: '',

            //nuevas variables
            nombresEstudiante: "",
            cedulaEstudianteSelect: "",
            numnivelescarr: '',
            periodosId: [],
            listaniveles: [],
            listanivelesIng: [],
            listaestudiantes: [],
            listacuotasestudiante: [],
            porcentaje_beca: 0,
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
            //variables programador2
            modalReportAbonosCuotaEst: false,
            modalPagoColegituraMes: false,
            cuotascolegiaturam: [],
            ruta: "",
            disabledformpag: true,
            disabledtransfe: true,
            disabledtotalbott: true,
            disabledaprorechvicerr: true,
            disablednumdeposith: true,
            enunciadonumdeposit: "Número de depósito(número de papeleta11111 o referencia)",
            form1: {
            },
            form: {
                id_pension_abono_mes: '',
            },
            disabledabonsinap: true,
            idMatriculaEstAux: '',
            idCarreraEstAux: '',
            idCicloEstAux: '',


        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {

            this.setState({ modalPagoColegituraMes: false });
            this.setState({ modalReportAbonosCuotaEst: false });

        }
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ carrera_seleccionada: this.state.idCarrera });
        this.setState({ estado: "" });
    }

    handleChangeDevolverIdCarreraIng = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(devuelNumNivelesCarrera, {
                idCarreraf: this.state.idCarreraIng,
                periodoIdf: this.state.periodoId,
            })
            .then(response => {
                this.setState({ listanivelesIng: response.data.data });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    handleChangeDevolverIdCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //var  = this.state.idCarrera;
        this.setState({ carrera_seleccionada: this.state.idCarrera });
        //devuelve los niveles de  una carrera y los datos registrados de colegiatura para cada uno de ellos
        axios
            .post(devuelNumNivelesCarrera, {
                idCarreraf: this.state.idCarrera,
                periodoIdf: this.state.periodoId,
            })
            .then(response => {
                const listaniveles1 = response.data.data;
                this.setState({ listaniveles: listaniveles1 });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }


    handleChangeDevolverIdCiclo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //var  = this.state.idCarrera;
        this.setState({ ciclo_seleccionado: this.state.idCiclo });
        //devuelve los niveles de  una carrera y los datos registrados de colegiatura para cada uno de ellos
    }

    handleChangeIngresarAsignMatCiclo = () => {
        this.setState({ modalIngresarAsignatura: true });
    }

    handleChangeListarAsignMatCiclo = () => {
        //var  = this.state.idCarrera;
        this.setState({ ciclo_seleccionado: this.state.idCiclo });
        //devuelve los niveles de  una carrera y los datos registrados de colegiatura para cada uno de ellos
        axios
            .post(UrlListarAsignMatCiclo, {
                idCarrera: this.state.carrera_seleccionada,
                idCiclo: this.state.ciclo_seleccionado,
            })
            .then(response => {
                var array = response.data.data;
                this.setState({ listaestudiantes: array });
                listaauxiliar = this.state.listaestudiantes;
                var cantidadestud = listaauxiliar.length;
                this.setState({ cantidadestud });
                //BÚSQUEDA
                const EstudianteBackup = this.state.listaestudiantes;

                this.setState((state) => {
                    return { EstudianteBackup: EstudianteBackup }
                });


                //PAGINACION
                this.setState({ itemOffset: 0 });
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });

                //FIN DE LA PAGINACION
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        //periodos
        axios.get(ApiUrl + "periodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(respuesta => {
                const periodos = respuesta.data.descripcion_periodo_academico;
                const periodosId = respuesta.data.id_periodo_academico;
                this.setState({ periodoId: respuesta.data.id_periodo_academico });
                this.setState({ periodos });
                this.setState({ periodosId });
                // console.log("periodos"+periodosId);
            })
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    mostrarModalAsignatura = (registro) => {
        $(function () {

            $("#id").val(registro.id_asignatura);
            $("#codigo").val(registro.codigo_asignatura);
            $("#descripcion").val(registro.descripcion_asignatura);
            $("#creditos").val(registro.creditos_asignatura);
            $("#hdocencia").val(registro.hora_docencia);
            $("#hpracticas").val(registro.hora_practica);
            $("#hautonomas").val(registro.hora_autonoma);
            $("#htotales").val(registro.hora_totales);
        });

        this.setState({ modalAsignatura: true, form: registro });
        this.setState({ id: registro.id_asignatura });
        this.setState({ codigo: registro.codigo_asignatura });
        this.setState({ descripcion: registro.descripcion_asignatura });
        this.setState({ creditos: registro.creditos_asignatura });
        this.setState({ hdocencia: registro.hora_docencia });
        this.setState({ hpracticas: registro.hora_practica });
        this.setState({ hautonomas: registro.hora_autonoma });
        this.setState({ htotales: registro.hora_totales });
    }

    ocultarModalIngresarAsignatura = () => {
        this.setState({ modalIngresarAsignatura: false });
    }

    ocultarModalAsignatura = () => {
        this.setState({ modalAsignatura: false });
    }

    ingresarAsignatura = () => {
        axios
            .post(urlIngrAsignatura, {
                codigo: this.state.codigoIng,
                descripcion: this.state.descripcionIng,
                creditos: this.state.creditosIng,
                hdocencia: this.state.hdocenciaIng,
                hpracticas: this.state.hpracticasIng,
                hautonomas: this.state.hautonomasIng,
                htotales: this.state.htotalesIng,
                idCarrera: this.state.idCarreraIng,
                idCiclo: this.state.idCicloIng,
            })
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Datos procesados correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    this.handleChangeListarAsignMatCiclo();
                } else {
                    swal({
                        text: "No se actualizó los datos",
                        icon: "error",
                        button: "Aceptar",
                    });
                    this.setState({ modalPagoColegituraMes: false });

                }
            })
            .catch(error => {

                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",

                });
            });

    }

    modificarAsignatura = () => {
        var combmsmalert = "¿Está seguro que desea modificar la asignatura?"
        swal({
            title: "Advertencia",
            text: combmsmalert,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {

                    axios
                        .post(urlModAsignatura, {
                            id: this.state.id,
                            codigo: this.state.codigo,
                            descripcion: this.state.descripcion,
                            creditos: this.state.creditos,
                            hdocencia: this.state.hdocencia,
                            hpracticas: this.state.hpracticas,
                            hautonomas: this.state.hautonomas,
                            htotales: this.state.htotales,
                        })
                        .then(response => {
                            if (response.data.success === true) {
                                swal({
                                    text: "Datos procesados correctamente",
                                    icon: "success",
                                    button: "Aceptar",
                                });
                                this.handleChangeListarAsignMatCiclo();
                            } else {
                                swal({
                                    text: "No se actualizó los datos",
                                    icon: "error",
                                    button: "Aceptar",
                                });
                                this.setState({ modalPagoColegituraMes: false });

                            }
                        })
                        .catch(error => {

                            this.setState({ error: "No existe conexión con el servidor" });
                            swal({
                                text: "No existe conexión con el servidor",
                                icon: "error",
                                button: "Aceptar",

                            });
                        });


                } else {
                    swal({
                        text: "¡Haz denegado la acción!",
                        icon: "warning",
                        button: "Aceptar",
                    });
                }
            });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b className="mb-0 fw-semibold">Gestión de Asignaturas</b>
                    </div>

                    <div className="p-3 rounded-3">
                        {/* Filtros */}
                        <div className="row g-3 mb-3">
                            {/* Carrera */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">Carrera</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCarrera"
                                    value={this.state.idCarrera}
                                    onChange={this.handleChangeDevolverIdCarrera}
                                >
                                    <option value="undefined" selected disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(p => (
                                        <option key={p.id_carrera} value={p.id_carrera}>
                                            {p.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Ciclos */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">Ciclos</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCiclo"
                                    value={this.state.idCiclo}
                                    onChange={this.handleChangeDevolverIdCiclo}
                                >
                                    <option value="undefined" selecteddisabled>Seleccione un ciclo</option>
                                    {this.state.listaniveles.map(n => (
                                        <option key={n.codnivel} value={n.codnivel}>
                                            {n.codnivel}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Botones */}
                            <div className="col-12 col-md-4 d-flex align-items-end">
                                <button
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm me-2"
                                    onClick={this.handleChangeListarAsignMatCiclo}
                                >
                                    Consultar
                                </button>
                                <button
                                    className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                    onClick={this.handleChangeIngresarAsignMatCiclo}
                                    hidden
                                >
                                    Nueva
                                </button>
                            </div>
                        </div>

                        {/* Tabla de asignaturas */}
                        <div className="table-responsive">
                            <table className="table table-sm table-hover align-middle small text-azul">
                                <thead className="table-light">
                                    <tr>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Créditos</th>
                                        <th>H. Docencia</th>
                                        <th>H. Prácticas</th>
                                        <th>H. Autónomas</th>
                                        <th>H. Totales</th>
                                        <th className="oculto">Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems?.map(item => (
                                        <tr key={item.id_asignatura}>
                                            <td className="oculto">{item.id_asignatura}</td>
                                            <td>{item.codigo_asignatura}</td>
                                            <td>{item.descripcion_asignatura}</td>
                                            <td>{item.creditos_asignatura}</td>
                                            <td>{item.hora_docencia}</td>
                                            <td>{item.hora_practica}</td>
                                            <td>{item.hora_autonoma}</td>
                                            <td>{item.hora_totales}</td>
                                            <td className="oculto">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => this.mostrarModalAsignatura(item)}
                                                >
                                                    <i className="fas fa-clipboard-list"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Paginador */}
                        <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={this.handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                containerClassName="pagination pagination-sm-custom"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>

                        {/* Modales */}
                        <Modal isOpen={this.state.modalAsignatura}>
                            <ModalHeader>
                                <div className="small mb-0 text-white">Asignatura</div>
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <div className="mb-3">
                                        <input type="hidden" name="id" onChange={this.handleChange} />
                                        <label className="form-label text-azul small">Código</label>
                                        <input
                                            type="text"
                                            name="codigo"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Nombre</label>
                                        <input
                                            type="text"
                                            name="descripcion"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Créditos</label>
                                        <input
                                            type="text"
                                            name="creditos"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Docencia</label>
                                        <input
                                            type="text"
                                            name="hdocencia"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Prácticas</label>
                                        <input
                                            type="text"
                                            name="hpracticas"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Autónomas</label>
                                        <input
                                            type="text"
                                            name="hautonomas"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Totales</label>
                                        <input
                                            type="text"
                                            name="htotales"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                    </div>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-sm btn-outline-primary me-2"
                                    onClick={this.modificarAsignatura}
                                >
                                    Modificar
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={this.ocultarModalAsignatura}
                                >
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.modalIngresarAsignatura}>
                            <ModalHeader>
                                <div className="small mb-0 text-white">Asignatura</div>
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <div className="mb-3">
                                        <input type="hidden" name="idIng" onChange={this.handleChange} />
                                        <label className="form-label text-azul small">Código</label>
                                        <input
                                            type="text"
                                            name="codigoIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Nombre</label>
                                        <input
                                            type="text"
                                            name="descripcionIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Carrera</label>
                                        <select
                                            className="form-select form-select-sm"
                                            name="idCarreraIng"
                                            value={this.state.idCarreraIng}
                                            onChange={this.handleChangeDevolverIdCarreraIng}
                                        >
                                            <option value="undefined" disabled>Seleccione una carrera</option>
                                            {this.state.carrera.map(p => (
                                                <option key={p.id_carrera} value={p.id_carrera}>
                                                    {p.descripcion_carrera}
                                                </option>
                                            ))}
                                        </select>
                                        <label className="form-label text-azul small mt-2">Ciclo</label>
                                        <select
                                            className="form-select form-select-sm"
                                            name="idCicloIng"
                                            value={this.state.idCicloIng}
                                            onChange={this.handleChangeDevolverIdCiclo}
                                        >
                                            <option value="undefined" disabled>Seleccione un ciclo</option>
                                            {this.state.listanivelesIng.map(n => (
                                                <option key={n.codnivel} value={n.codnivel}>
                                                    {n.codnivel}
                                                </option>
                                            ))}
                                        </select>
                                        <label className="form-label text-azul small mt-2">Créditos</label>
                                        <input
                                            type="text"
                                            name="creditosIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Docencia</label>
                                        <input
                                            type="text"
                                            name="hdocenciaIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Prácticas</label>
                                        <input
                                            type="text"
                                            name="hpracticasIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Autónomas</label>
                                        <input
                                            type="text"
                                            name="hautonomasIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                        <label className="form-label text-azul small mt-2">Horas Totales</label>
                                        <input
                                            type="text"
                                            name="htotalesIng"
                                            onChange={this.handleChange}
                                            className="form-control form-control-sm"
                                            required
                                        />
                                    </div>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <button
                                    className="btn btn-sm btn-outline-primary me-2"
                                    onClick={this.ingresarAsignatura}
                                >
                                    Ingresar
                                </button>
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={this.ocultarModalIngresarAsignatura}
                                >
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

